export function currencyFormatter(num: number) {
  if(!num) return '$ 0.00'
  return '$' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}
